import { useIntl } from 'react-intl';

const Logo = (props) => {
    const intl = useIntl();

    return (
        <img
            src={process.env.PUBLIC_URL + '/logo.svg'}
            alt={intl.formatMessage({ id: 'common_ascend_logo' })}
            width={props.width || 116}
            {...props}
        />
    );
};

export default Logo;
